/* eslint-disable camelcase */
import { SET_PICKER_EXCLUDED } from 'reducers/actions-types';
import { request, fetchNextChunk as _fetchNextChunk } from './helpers';


export default {
    fetch() {
        return request();
    },
    fetchNextChunk() {
        return _fetchNextChunk();
    },
    /**
     * Exclude picker
     * @param {string} person_id
     * @param {boolean} excluded
     * @return {{excluded: *, type: *, person_id: *}}
     */
    setExcluded({ person_id, excluded }) {
        return { type: SET_PICKER_EXCLUDED, person_id, excluded };
    },
};




// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/pickers/actions.js